import React from 'react';
import "./TournamentHistory.css"
import Select from 'react-select-me';
import FontAwesome from 'react-fontawesome';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import i18next from 'i18next'
class TournamentFilter extends React.Component {
    constructor(props) {
        super(props);
        let { buyIn, gameSubType, trnyType, gameSpeed, dateRange, feedGameType } = this.props.activeTournyFilter
        this.state = {
            feedGameType: this.props.myStatSettings.gameType === 'tournament' ? 'MTT' : this.props.myStatSettings.gameType,
            buyIn, gameSubType, trnyType, gameSpeed, dateRange,
            optionsBuyIn: [{ value: 'All', label: 'All' }, { value: 'High:$55+', label: 'High: $55+' }, { value: 'Medium:$20-$55', label: 'Medium: $20 - $55' }, { value: 'Low:$5.50-$20', label: 'Low: $5.50 - $20' }, { value: 'Micro:<$5.50', label: 'Micro: <$5.50' }],
            optionsGametype: [{ value: 'All', label: 'All' }, { value: 'NLH', label: 'NLH' }, { value: 'Omaha', label: 'Omaha' }, { value: 'Omaha hl', label: 'Omaha hl' }],
            optionsDates: [{ value: 'Today', label: i18next.t("lable.Today")}
                , { value: 'Yesterday', label: i18next.t("lable.Yesterday")}, { value: 'Last 7 days', label: i18next.t("lable.Last 7 days")}
                , { value: 'This Week', label: i18next.t("lable.This Week")}, { value: 'Last Week', label: i18next.t("lable.Last Week")}
                , { value: 'This Month', label: i18next.t("lable.This Month")}, { value: 'Last Month', label: i18next.t("lable.Last Month")}
                , { value: 'This Year', label: i18next.t("lable.This Year")}, { value: 'Last Year', label: i18next.t("lable.Last Year")}]
        }
    }

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }
    componentWillReceiveProps(prevProps, prevState) {
        let selectedGameType = this.props.myStatSettings.gameType === 'tournament' ? 'MTT' : this.props.myStatSettings.gameType
        if (this.props.activeTournyFilter.feedGameType !== selectedGameType) {
            let { buyIn, gameSubType, trnyType, gameSpeed, dateRange, feedGameType } = this.props.activeTournyFilter
            this.setState({
                feedGameType: selectedGameType,
                buyIn, gameSubType, trnyType, gameSpeed, dateRange
            })
        }
    }

    render() {
        let { tournamentTypeList, tournamentSpeedList } = this.props,
            { optionsBuyIn, optionsGametype, optionsDates, buyIn, gameSubType, trnyType, gameSpeed, dateRange } = this.state
        trnyType = trnyType === "" ? tournamentTypeList[0].value : trnyType
        gameSpeed = gameSpeed === "" ? tournamentSpeedList[0].value : gameSpeed

        return (
            <div className="modal fade" data-backdrop="static" id="settingModalTournaments" role="dialog">
                <div className="ms_modal_dialog ms_setting_modal_dialog">
                    <div className="modal-content ms_modal-content">
                        <div className="ms_setting_container">
                            <div className="ms_setting_title">{i18next.t("lable.tournamentHistoryFilters")}</div>
                            <div className="ms_select_container">
                                <label className="ms_select_label">{i18next.t("lable.buyIn")}</label>
                                <Select options={optionsBuyIn} value={buyIn}
                                    onChange={(option) => { this.onChange({ target: { name: "buyIn", value: option.value } }); }} />
                                <span className="ms_select_arrow">
                                    <FontAwesome name="fas fa-angle-down" style={{ verticalAlign: "sub", fontWeight: "bold" }} />
                                </span>
                            </div>
                            {
                                trnyType &&
                                <div className="ms_select_container">
                                    <label className="ms_select_label">{i18next.t("lable.tournamentType")}</label>
                                    <Select options={tournamentTypeList} value={trnyType}
                                        onChange={(option) => { this.onChange({ target: { name: "trnyType", value: option.value } }); }} />
                                    <span className="ms_select_arrow">
                                        <FontAwesome name="fas fa-angle-down" style={{ verticalAlign: "sub", fontWeight: "bold" }} />
                                    </span>
                                </div>

                            }
                            <div className="ms_select_container">
                                <label className="ms_select_label">{i18next.t("lable.gameType")}</label>
                                <Select options={optionsGametype} value={gameSubType}
                                    onChange={(option) => { this.onChange({ target: { name: "gameSubType", value: option.value } }); }} />
                                <span className="ms_select_arrow">
                                    <FontAwesome name="fas fa-angle-down" style={{ verticalAlign: "sub", fontWeight: "bold" }} />
                                </span>
                            </div>
                            <div className="ms_select_container">
                                <label className="ms_select_label">{i18next.t("lable.dates")}</label>
                                <Select options={optionsDates} value={dateRange}
                                    onChange={this.onChange} onChange={(option) => { this.onChange({ target: { name: "dateRange", value: option.value } }); }} />
                                <span className="ms_select_arrow">
                                    <FontAwesome name="fas fa-angle-down" style={{ verticalAlign: "sub", fontWeight: "bold" }} />
                                </span>
                            </div>
                            {gameSpeed &&
                                <div className="ms_select_container">
                                    <label className="ms_select_label">{i18next.t("lable.gameSpeed")}</label>
                                    <Select options={tournamentSpeedList} value={gameSpeed}
                                        onChange={(option) => { this.onChange({ target: { name: "gameSpeed", value: option.value } }); }} />
                                    <span className="ms_select_arrow">
                                        <FontAwesome name="fas fa-angle-down" style={{ verticalAlign: "sub", fontWeight: "bold" }} />
                                    </span>
                                </div>
                            }
                            <div className="ms_settingButton_container">
                                <button
                                    data-e2e="myStats-save-setting-button"
                                    data-dismiss="modal"
                                    className={`mg-btn ms_saveSetting_btn`}
                                    onClick={() => this.props.saveSetting({ buyIn, gameSubType, trnyType, gameSpeed, dateRange })}
                                ><span className="ms_saveSetting_text">{i18next.t("lable.SAVE")}</span></button>
                            </div>
                        </div>
                        <span className="ms_setting_closeButton" data-dismiss="modal">
                            <FontAwesome name="fas fa-times" />
                        </span>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        tournamentHistoryFlag: state.multipleReportCards.tournamentHistoryFlag,
        tournamentHistoryFullScreenFlag: state.multipleReportCards.tournamentHistoryFullScreenFlag,
        tournyDtls: state.multipleReportCards.tournyDtls,
        tournamentTypeList: state.multipleReportCards.tournytype,
        activeTournyFilter: state.multipleReportCards.activeTournyFilter,
        myStatGameType: state.multipleReportCards.myStatGameType,
        myStatSettings: state.multipleReportCards.myStatSettings,
        lang: state.header.lang

    };
};



export default connect(mapStateToProps, null)(TournamentFilter);



/** WEBPACK FOOTER **
 ** ./src/components/MyStatistics/TournamentFilter.js
 **/